import React, { useMemo } from 'react';

  const generateTimes = (minTime = '06:00', maxTime = '24:00') => {
  const times = [];
  const [minH, minM] = minTime.split(':').map(Number);
   const [maxH, maxM] = maxTime.split(':').map(Number);
for (let h = 6; h < 24; h++) {
    for (let m = 0; m < 60; m += 5) {
     if ((h > minH || (h === minH && m >= minM)) && (h < maxH || (h === maxH && m <= maxM))) {
        const hStr = String(h).padStart(2, '0');
        const mStr = String(m).padStart(2, '0');
        times.push(`${hStr}:${mStr}`);
      }
    }
  }
  return times;
};

const TimeSelect = ({ value, onChange, minTime, placeholder = 'Velg tid', className = '' }) => {
  const times = useMemo(() => generateTimes(minTime), [minTime]);

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
className={`w-full border border-cream-200 dark:border-dark-50 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-navy-400 dark:focus:ring-gold-500 bg-white dark:bg-dark-100 text-navy-900 dark:text-cream-100 ${className}`}
    >
      <option value="">{placeholder}</option>
      {times.map((t) => (
        <option key={t} value={t}>{t}</option>
      ))}
    </select>
  );
};

export default TimeSelect;
